import { formatPersianDateTime } from './persianNumber';

/** Shared approval status labels for daily report UI + print. */
export function getDailyReportApprovalDisplay(approvalStatus) {
  if (!approvalStatus?.submitted) return null;

  if (approvalStatus.approved) {
    const whenFormatted = approvalStatus.approved_at
      ? formatPersianDateTime(approvalStatus.approved_at)
      : null;
    const approver = approvalStatus.approved_by_name || 'مدیر دپارتمان';
    return {
      label: 'تایید شده',
      detail: whenFormatted ? `توسط ${approver} · ${whenFormatted}` : `توسط ${approver}`,
      when: whenFormatted,
      bg: '#f0fdf4',
      border: '#86efac',
      color: '#166534',
      icon: '✓',
    };
  }

  if (approvalStatus.needs_reapproval) {
    return {
      label: 'نیاز به تایید مجدد',
      detail: 'پس از ویرایش، مدیر دپارتمان باید گزارش را دوباره تایید کند.',
      when: null,
      bg: '#fffbeb',
      border: '#fde68a',
      color: '#92400e',
      icon: '↻',
    };
  }

  return {
    label: 'در انتظار تایید',
    detail: 'گزارش ثبت شده و منتظر تایید مدیر دپارتمان است.',
    when: null,
    bg: '#f8fafc',
    border: '#cbd5e1',
    color: '#475569',
    icon: '⏳',
  };
}

export function normalizeDailyReportApproval(payload) {
  if (!payload || Array.isArray(payload)) return null;
  return {
    approved: !!payload.approved,
    approved_at: payload.approved_at || null,
    approved_by_name: payload.approved_by_name || null,
    manager_signature_file: payload.manager_signature_file || null,
    submitted: !!payload.submitted,
    needs_reapproval: !!payload.needs_reapproval,
  };
}

export function normalizeManagerDailyReportApproval(approval) {
  if (!approval) return null;
  return {
    approved: !!approval.approved,
    approved_at: approval.approved_at || null,
    approved_by_name: approval.approved_by_name || null,
    manager_signature_file: approval.manager_signature_file || null,
    submitted: approval.submitted !== false,
    needs_reapproval: !!approval.needs_reapproval,
  };
}
